import { Paragraph, Spacing } from "@sicredi/react";
import { CardTracking } from "../CardTracking";
import { ITrackingComponents } from "../model";
import { PAGE } from "#/constants";
import { useNavigate } from "react-router-dom";
import { ButtonLinkChevronRight } from "#/components/ButtonLinkChevronRight";
import { formatDate } from "#/contextProver/ContextProverServices";
import styles from "./styles.module.scss";

export const AssembleiaTracking: React.FC<ITrackingComponents> = ({
  state,
  paragraphSize,
  assembleiaDate,
  isBoletoPago,
}) => {
  const navigate = useNavigate();

  return (
    <div>
      <CardTracking
        title="Assembleia"
        state={state}
        isIconClock={!isBoletoPago}
      >
        {state && isBoletoPago && (
          <>
            <Paragraph size={paragraphSize(state)} weight="normal">
              <strong>Primeira assembleia do grupo:</strong>
              {formatDate(assembleiaDate as string)}
            </Paragraph>

            <div className={styles.button_container}>
              <ButtonLinkChevronRight
                text="O que são as assembleias?"
                onClick={() => navigate(PAGE.FAQ)}
              />
            </div>
          </>
        )}

        {!state && (
          <>
            {isBoletoPago && (
              <>
                <Paragraph size={paragraphSize(state)} weight="normal">
                  A data da primeira assembleia do grupo será informada em até
                  30 dias.
                </Paragraph>

                <div className={styles.button_container}>
                  <ButtonLinkChevronRight
                    text="O que são as assembleias?"
                    onClick={() => navigate(PAGE.FAQ)}
                  />
                </div>
              </>
            )}
            {!state && !isBoletoPago && <Spacing appearance="x-large" />}
          </>
        )}
      </CardTracking>
    </div>
  );
};
